import React from 'react';
import AdminLayout from '../../../components/layout/AdminLayout';
import CompetitionResultForm from '../../../components/forms/CompetitionResultForm';
import { useCreateCompetitionResult } from '../../../hooks/useCompetitionResultApi';
import { useNavigate } from 'react-router-dom';
import { CompetitionResultDTO } from '../../../services/apiClient';

const CompetitionResultCreate: React.FC = () => {
  const createCompetitionResult = useCreateCompetitionResult();
  const navigate = useNavigate();

  const breadcrumbs = [
    { label: 'Admin', href: '#' },
    { label: 'Competition Results', href: '/admin/competitionresults' },
    { label: 'Create', href: '#' },
  ];

  const handleSubmit = async (data: CompetitionResultDTO) => {
    try {
      await createCompetitionResult.mutateAsync(data);
      navigate('/admin/competitionresults');
    } catch (error) {
      console.error('Error creating CompetitionResult:', error);
    }
  };

  return (
    <AdminLayout
      activeMenuItem="/admin/competitionresults"
      breadcrumbs={breadcrumbs}
      allowedRoles={['Admin']}
      requiredPermission='Manage.CompetitionResult.Edit'
    >
      <CompetitionResultForm
        initialValues={{} as CompetitionResultDTO}
        onSubmit={handleSubmit}
        onCancel={() => navigate('/admin/competitionresults')}
      />
    </AdminLayout>
  );
};

export default CompetitionResultCreate;
